"use strict";
import { useCallback, useMemo } from "react";
import { Trans, useTranslation } from "react-i18next";
import { Flex, Separator, Text, useIsDarkMode } from "ui/src";
import { CRYPTO_PURCHASE_BACKGROUND_DARK, CRYPTO_PURCHASE_BACKGROUND_LIGHT } from "ui/src/assets";
import { ArrowDownCircle } from "ui/src/components/icons/ArrowDownCircle";
import { ActionCard } from "components/misc/ActionCard";
import { useCexTransferProviders } from "features/fiatOnRamp/useCexTransferProviders";
import { ElementName } from "features/telemetry/constants";
export const EmptyWallet = ({
  handleSwapCryptoClick,
  handleReceiveCryptoClick,
  handleCEXTransferClick
}) => {
  const { t } = useTranslation();
  const isDarkMode = useIsDarkMode();
  const providers = useCexTransferProviders();
  const BackgroundImageWrapperCallback = useCallback(
    ({ children }) => {
      return <BackgroundImage image={isDarkMode ? CRYPTO_PURCHASE_BACKGROUND_DARK : CRYPTO_PURCHASE_BACKGROUND_LIGHT}>
          {children}
        </BackgroundImage>;
    },
    [isDarkMode]
  );
  const options = useMemo(
    () => [
      {
        title: t("home.empty.transfer"),
        blurb: t("home.empty.transfer.description"),
        elementName: ElementName.EmptyStateReceive,
        icon: <ArrowDownCircle color="$neutral2Temp" size="$icon.28" />,
        onPress: handleReceiveCryptoClick
      }
    ],
    [
      providers,
      BackgroundImageWrapperCallback,
      handleSwapCryptoClick,
      handleReceiveCryptoClick,
      handleCEXTransferClick,
      t
    ]
  );
  return <Flex gap="$spacing20">
      <Separator />
      <Flex>
        <Text variant="subheading2" color="$neutral1">
          <Trans i18nKey="onboarding.welcome.title" />
        </Text>
        <Text variant="body3" color="$neutral2">
          <Trans i18nKey="home.tokens.empty.welcome.description" />
        </Text>
      </Flex>
      <Flex gap="$spacing12">
        {options.map((option) => <ActionCard
    key={option.title}
    {...option}
    leftAlign
    hoverStyle={{
      backgroundColor: "$surface1Hovered",
      borderColor: "$surface3Hovered"
    }}
  />)}
      </Flex>
    </Flex>;
};
const BackgroundImage = ({ children, image }) => {
  return <Flex>
      <img
    src={image}
    width="100%"
    height="100%"
    style={{
      position: "absolute",
      zIndex: -1,
      borderRadius: 24,
      objectFit: "cover",
      filter: "blur(2px)"
    }}
  />
      {children}
    </Flex>;
};
